/**
 * Transforms a workout plan from the AI's compact format (with a SETS measurement)
 * to the form's explicit format where each action represents one set.
 * This ensures data consistency for UI components.
 * @param {object} plan - The workout plan object.
 * @returns {object} The transformed workout plan object.
 */
export const transformAiPlan = (plan) => {
  if (!plan || !plan.stages) return plan;
  const newPlan = JSON.parse(JSON.stringify(plan));
  newPlan.stages.forEach(stage => {
    if (!stage.activities) return;
    stage.activities.forEach(activity => {
      if (!activity.actions || activity.actions.length === 0) return;
      const expandedActions = [];
      activity.actions.forEach(action => {
        const setsMeasurement = action.prescribed_measurements?.find(m => m.type === 'SETS');
        const numSets = setsMeasurement?.target_value;
        if (numSets && numSets > 0) {
          const measurementsToCopy = action.prescribed_measurements.filter(m => m.type !== 'SETS');
          for (let i = 0; i < numSets; i++) {
            expandedActions.push({
              ...action,
              component_id: `${action.component_id || 'actn'}_set${i + 1}`,
              prescribed_measurements: JSON.parse(JSON.stringify(measurementsToCopy)),
              purpose: action.purpose || 'WORKING' // Ensure purpose is carried over or defaulted
            });
          }
        } else {
          // Ensure default purpose exists if missing
          if (!action.purpose) action.purpose = 'WORKING';
          expandedActions.push(action);
        }
      });
      activity.actions = expandedActions;
    });
  });
  return newPlan;
};